module.exports = __webpack_public_path__ + "dfd57473a9cc69a22c6202a38928b35a.jpg";